/**makeSelectLogs
 * Combine all reducers in this file and export the combined reducers.
 */

import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router';
import history from '../utils/history';

import {State as LoginState} from '../pages/login/interfaces';
import {State as OrderState} from '../pages/orders/interfaces';
import {State as BundleState} from '../pages/bundles/interfaces';
import {State as UserState} from '../pages/users/interfaces';
import {State as PartnersState} from '../pages/partners/interfaces';
import {State as CentersState} from '../pages/centers/interfaces';
import {State as ProductsState} from '../pages/products/interfaces';
import {State as WarehousesState} from '../pages/warehouses/interfaces';
import {State as ReportsState} from '../pages/reports/interfaces';
import {State as ParcelsState} from '../pages/parcels/interfaces';
// import {State as WebhooksState} from '../pages/webhooks/interfaces';
// import {State as WarehouseZonesState} from '../pages/warehouseZones/interfaces';
// import {State as WarehouseZoneAislesState} from '../pages/warehouseZone-aisles/interfaces';
// import {State as WarehouseZoneColumnsState} from '../pages/warehouseZone-column/interfaces';
// import {State as WarehouseZoneRowsState} from '../pages/warehouseZone-row/interfaces';
// import {State as WarehouseZoneUnitsState} from '../pages/warehouseZone-unit/interfaces';
import {State as ProvidersState} from '../pages/providers/interfaces';
import {State as SellersState} from '../pages/sellers/interfaces';

import LoginReducer from '../pages/login/reducer';
import OrdersReducer from '../pages/orders/reducer';
import BundlesReducer from '../pages/bundles/reducer';
import UsersReducer from '../pages/users/reducer';
import PartnersReducer from '../pages/partners/reducer';
import CentersReducer from '../pages/centers/reducer';
import ProductsReducer from '../pages/products/reducer';
import WarehousesReducer from '../pages/warehouses/reducer';
import ReportsReducer from '../pages/reports/reducer';
import ParcelsReducer from '../pages/parcels/reducer';
// import WarehouseZoneReducer from '../pages/warehouseZones/reducer';
// import WarehouseZoneAisleReducer from '../pages/warehouseZone-aisles/reducer';
// import WarehouseZoneColumnReducer from '../pages/warehouseZone-column/reducer';
// import WarehouseZoneRowReducer from '../pages/warehouseZone-row/reducer';
// import WarehouseZoneUnitReducer from '../pages/warehouseZone-unit/reducer';
// import WebhooksReducer from '../pages/webhooks/reducer';
import ProviderReducer from '../pages/providers/reducers';
import SellerReducer from '../pages/sellers/reducers';
import InvoicesReducer from '../pages/bill/saga/reducer';

export interface Store {
  login: LoginState;
  orders: OrderState;
  bundles: BundleState;
  users: UserState;
  partners: PartnersState;
  centers: CentersState;
  products: ProductsState;
  warehouses: WarehousesState;
  // warehouseZones: WarehouseZonesState;
  // warehouseZoneAisles: WarehouseZoneAislesState;
  // warehouseZoneColumns: WarehouseZoneColumnsState;
  // warehouseZoneRows: WarehouseZoneRowsState;
  // warehouseZoneUnits: WarehouseZoneUnitsState;
  reports: ReportsState;
  parcels: ParcelsState;
  // webhooks: WebhooksState;
  providers: ProvidersState;
  sellers: SellersState;
  router: any;
  invoices:any;
}

export default combineReducers<Store>({
  login: LoginReducer,
  orders: OrdersReducer,
  bundles: BundlesReducer,
  users: UsersReducer,
  partners: PartnersReducer,
  centers: CentersReducer,
  products: ProductsReducer,
  warehouses: WarehousesReducer,
  // warehouseZones: WarehouseZoneReducer,
  // warehouseZoneAisles: WarehouseZoneAisleReducer,
  // warehouseZoneColumns: WarehouseZoneColumnReducer,
  // warehouseZoneRows: WarehouseZoneRowReducer,
  // warehouseZoneUnits: WarehouseZoneUnitReducer,
  // webhooks: WebhooksReducer,
  reports: ReportsReducer,
  parcels: ParcelsReducer,
  providers: ProviderReducer,
  sellers: SellerReducer,
  invoices: InvoicesReducer,
  router: connectRouter(history),
});
